export default __webpack_public_path__ + "static/media/cash.4bd7672d.svg";